import { lazy, Suspense, useEffect } from 'react';

import { Route, Switch } from 'react-router-dom';

import AppAlert from '@m/components/AppAlert';
import { useHeapIdentifyUser } from '@m/hooks/useHeapIdentifyUser';
import { KeycloakService } from '@m/keycloak-service/KeycloakService';
import { Wrapper } from '@m/legacy-auth/components/Layout';
import { useIsAuthed } from '@m/legacy-auth/hooks/useIsAuthed';
import { getUser } from '@m/legacy-auth/state/user';
import { fetchEnums, fetchLPStates } from '@m/state/enum';
import { User } from '@m/types/api';
import { userAnalytics } from '@m/utils/userAnalytics';
import { fetchForceCloseReasons } from 'apps/specialist/state/visit';

const SiteChooserContainer = lazy(() => import('apps/specialist/containers/SiteChooserContainer'));
const SiteContainer = lazy(() => import('apps/specialist/containers/SiteContainer'));
const NavbarContainer = lazy(() => import('apps/specialist/containers/NavbarContainer'));

export default function Specialist() {
  const isAuthed = useIsAuthed();

  // initial fetch of user data
  useEffect(() => {
    getUser();
    fetchEnums({ isAdmin: true });
    fetchLPStates();
  }, []);

  useEffect(() => {
    if (isAuthed) {
      userAnalytics.setUser(KeycloakService.getUserObject() as User);
      // fetch necessary data after authenticated
      fetchForceCloseReasons();
    }
  }, [isAuthed]);

  useHeapIdentifyUser({
    authenticated: isAuthed,
    user: KeycloakService.getUserObject() as User,
  });

  return (
    <>
      <AppAlert />
      <Wrapper>
        <Suspense fallback={null}>{isAuthed && <NavbarContainer />}</Suspense>
        <Switch>
          <Route exact path="/">
            <Suspense fallback={null}>{isAuthed && <SiteChooserContainer />}</Suspense>
          </Route>
          <Route exact path="/site/:siteId">
            <Suspense fallback={null}>{isAuthed && <SiteContainer />}</Suspense>
          </Route>
        </Switch>
      </Wrapper>
    </>
  );
}
